import { render, staticRenderFns } from "./OverlayAlert.vue?vue&type=template&id=0e9a9a0a&scoped=true"
import script from "./OverlayAlert.vue?vue&type=script&lang=js"
export * from "./OverlayAlert.vue?vue&type=script&lang=js"
import style0 from "./OverlayAlert.vue?vue&type=style&index=0&id=0e9a9a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a9a0a",
  null
  
)

export default component.exports